import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { usePermissions } from '../providers/permissions-provider';
import Forbidden from '../pages/forbidden';

interface PermissionGuardProps {
    resource: string;
    children: React.ReactNode;
}

// Wrap a route's element with this to block access when the current user's role
// doesn't have read permission for the given resource - shows the Forbidden page instead
const PermissionGuard: React.FC<PermissionGuardProps> = ({ resource, children }) => {
    const { can, isLoading } = usePermissions();

    if (isLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '70vh' }}>
                <CircularProgress sx={{ color: 'var(--color-primary)' }} />
            </Box>
        );
    }

    if (!can(resource, 'read')) {
        return <Forbidden />;
    }

    return <>{children}</>;
};

export default PermissionGuard;
